<app-top-bar />
<div class="flex-1">
  <router-outlet />
</div>
